import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const AccessControlInput = () => {
  const { controlId = '' } = useParams();
  const decodedId = controlId ? atob(controlId) : controlId;
  const id = /^[0-9a-fA-F-]{36}$/.test(decodedId) ? decodedId : decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'accessControl';

  useEffect(() => {
    if (controlId) {
      setIsEditing(true);
      fetchDetails();
    }
  }, [controlId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['accessControl'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching AccessControl details:', error);
    }
  };

  const fields = [
    {
      name: 'user',
      label: 'User',
      type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
      required: true,
      readOnly: isEditing, // User field cannot be changed once created (OneToOne relationship)
    },
    {
      name: 'role',
      label: 'Role',
      type: 'select',
      required: true,
      options: [
        { value: 'ADMIN', label: 'Admin' },
        { value: 'ACCOUNTANT', label: 'Accountant' },
        { value: 'VIEWER', label: 'Viewer' },
      ],
    },
    {
      name: 'can_view_reports',
      label: 'Can View Reports',
      type: 'checkbox',
    },
    {
      name: 'can_edit_transactions',
      label: 'Can Edit Transactions',
      type: 'checkbox',
    },
    {
      name: 'can_approve_payments',
      label: 'Can Approve Payments',
      type: 'checkbox',
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Access Control' : 'Create Access Control'}</h1>
      <FormComponent
        fields={fields}
        initialFormData={formData}
        route={route}
        cancelPath="/security/access-control/list"
      />
    </div>
  );
};

export default AccessControlInput;
